





























import { Component, Vue, Prop } from 'vue-property-decorator';
import { BankAccount, MangoPayMandates } from '@/store/mangoPay/types';
import BankAccountListSelector from '@/components/bankAccount/shared/BankAccountListSelector.vue';

@Component({
  name: 'bank-overview-card',
  components: {
    BankAccountListSelector,
  },
})
export default class BankAccountList extends Vue {
  @Prop({ default: undefined, required: true }) accounts?: Array<BankAccount>;
  @Prop({ required: true }) mandates: MangoPayMandates;

  get hasBankAccount() {
    return this.accounts && this.accounts.length > 0;
  }

  get selectedBankAccount() {
    return this.$route.params.accountId ? this.$route.params.accountId : '';
  }

  onBankSelect(bankAccountId: string) {
    this.$router.push(`/bank-account/${bankAccountId}`);
  }
}
